import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useGetRooms } from 'store/services/firebase-broadcast';

const RoomRedirect: React.FC = () => {
  const { roomId } = useParams<{ roomId: string }>();
  const history = useHistory();
  const allRooms = useGetRooms();

  useEffect(() => {
    if (roomId && allRooms.length > 0) {
      const roomIdNumber = parseInt(roomId, 10);
      const roomFromUrl = allRooms.find((room: any) => room.pk === roomIdNumber);
      
      if (roomFromUrl) {
        // Immediate redirect with room data
        history.replace('/chat-room', { selected: roomFromUrl });
      } else {
        // Room not found, redirect to conversations
        history.replace('/conversations-nearby');
      }
    }
  }, [roomId, allRooms, history]);

  // Show clean loading state during redirect (no "Redirecting..." text)
  return <div></div>;
};

export default RoomRedirect;
